const SalaryRangeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z"
        fill="#85C553"
      />
      <path
        d="M24 29.3333C23.2667 29.3333 22.6391 29.0724 22.1173 28.5507C21.5956 28.0289 21.3342 27.4009 21.3333 26.6667C21.3324 25.9324 21.5938 25.3049 22.1173 24.784C22.6409 24.2631 23.2684 24.0018 24 24C24.7316 23.9982 25.3596 24.2596 25.884 24.784C26.4084 25.3084 26.6693 25.936 26.6667 26.6667C26.664 27.3973 26.4031 28.0253 25.884 28.5507C25.3649 29.076 24.7369 29.3369 24 29.3333ZM17.8333 17.3333H30.1667L31.8667 13.9333C32.0889 13.4889 32.072 13.0556 31.816 12.6333C31.56 12.2111 31.1769 12 30.6667 12H17.3333C16.8222 12 16.4391 12.2111 16.184 12.6333C15.9289 13.0556 15.912 13.4889 16.1333 13.9333L17.8333 17.3333ZM19.2 36H28.8C30.8 36 32.5 35.3058 33.9 33.9173C35.3 32.5289 36 30.8231 36 28.8C36 27.9556 35.8556 27.1333 35.5667 26.3333C35.2778 25.5333 34.8667 24.8111 34.3333 24.1667L30.8667 20H17.1333L13.6667 24.1667C13.1333 24.8111 12.7222 25.5333 12.4333 26.3333C12.1444 27.1333 12 27.9556 12 28.8C12 30.8222 12.6947 32.528 14.084 33.9173C15.4733 35.3067 17.1787 36.0009 19.2 36Z"
        fill="#F3F9EE"
      />
    </svg>
  );
};

export default SalaryRangeIcon;
